import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { NotAuthenticatedUserError } from '@errors/error';
import { AuthService } from '@services/auth.service';

/** 権限 */
type Role = 'system_admin' | 'tenant_admin' | 'tenant_editor' | 'tenant_viewer';

/**
 * 引数に渡されたユーザー権限の配列に所属するユーザー権限を持つユーザならそのまま遷移させる
 * そうでない場合はログイン画面に遷移させる
 * @param {Number} roles 画面にそのまま遷移してよいユーザの権限からなる配列
 * @return {CanActivateFn} ガード
 */
export const createUserRoleGuard = (roles: Array<Role>): CanActivateFn => {
  return async () => {
    const authService = inject(AuthService);
    const router = inject(Router);

    const loggedInUser = authService.loggedInUser;
    if (!loggedInUser) {
      throw new NotAuthenticatedUserError();
    }
    const role = loggedInUser.tenant.roleId;

    const isValid = roles.includes(role);
    if (!isValid) {
      return router.parseUrl('/login');
    }
    return true;
  };
};
